<template>
  <div class="center">
    <!-- 返回按键 -->
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 条件筛选框 -->
    <div class="waitingcom_title">
      <!-- 表单 -->
      <el-form
        :model="formLabelAlign"
        ref="formLabelAlign"
        label-width="80px"
        :label-position="labelPosition"
      >
        <el-form-item label="考生姓名：">
          <el-input
            v-model.trim="formLabelAlign.userName"
            placeholder="请输入考生姓名"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 搜索按钮 -->
      <div class="query_btn">
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetQuery"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
      </div>
    </div>

    <!-- 列表全局按钮 -->
    <div class="oper_box">
      <el-button @click="batchDeleteInit(1)" plain
        ><i class="iconfont icon-action-add-hover"></i>批量同意</el-button
      >
      <el-button @click="batchDeleteInit(2)" plain
        ><i class="iconfont icon-yichu"></i>批量拒绝</el-button
      >
    </div>
    <!-- 表格内容 -->
    <div class="content_table">
      <el-table
        ref="table"
        :data="getData"
        @selection-change="handleSelectionChange"
        @row-click="stepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
        v-loading="isLoading"
      >
        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          type="selection"
          width="60"
          align="center"
          :reserve-selection="true"
        ></el-table-column>

        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="350">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                @click.stop="examine(1, scope.row)"
                >同意</el-button
              >
              <el-button
                type="text"
                size="small"
                style="color: red"
                @click.stop="examine(2, scope.row)"
                >拒绝</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="total"
          class="pagination"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        userName: "",
      },
      getDataCondition: {
        userName: "",
      },
      getData: [],
      formColumns: [
        {
          prop: "RealName",
          label: "姓名",
          // width: "90px",
        },
        {
          prop: "PTitle",
          label: "原职称",
        },
        {
          prop: "waitPTitle",
          label: "申请变更职称",
        },
      ],
      currentPage: 1,
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
      isLoading: false,
      multipleSelectionIds: [],
      multipleSelection: [],
      multipleSelectionCount: 0,
    };
  },
  props: ["changes"],
  activated() {
    this.getDatalist();
  },
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.changes(0);
    },
    // 搜索
    handleQuery() {
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      this.formLabelAlign.userName = this.formLabelAlign.userName
        ? this.formLabelAlign.userName
        : this.getDataCondition.userName;
      this.getDatalist();
    },
    // 重置
    resetQuery() {
      this.formLabelAlign.userName = "";
      this.getDataCondition.userName = "";
      this.$refs.table.clearSelection();
      this.getDatalist();
    },
    // 获取表格
    async getDatalist() {
      this.isLoading = true;
      const obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        pageIndex: this.currentPage - 1,
        eachPageNum: this.pageSize,
        userName: this.formLabelAlign.userName,
      };
      const { data } = await systemclass.PTitleWaitList(obj);
      if (data.Status == 200) {
        console.log(data);
        this.getData = data.Data.data;
        this.total = data.Data.count;
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      } else {
        this.$message.error(data.Msg);
        this.isLoading = false;
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.eachPageNum = val;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      console.log(`当前页: ${val}`);
      this.loading = true;
      this.getDatalist(); // 重新发起请求
    },
    // 表格多选框改变时触发
    handleSelectionChange(rows) {
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      // 将数据存入
      rows.forEach((row) => {
        this.multipleSelectionIds.push(row.UserID);
      });
      this.multipleSelection = rows;
      this.multipleSelectionCount = this.multipleSelection.length;
      // 全局按钮样式配置
      this.multiple = !this.multipleSelection.length;
    },
    // 勾选当前行激活check
    stepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.UserID;
    },
    // 审批
    examine(type, row, types) {
      let str = types
        ? `此操作将批量${type == 1 ? "同意" : "拒绝"}“${
            this.multipleSelectionIds.length
          }”名考生？`
        : `此操作将${type == 1 ? "同意" : "拒绝"}名为“${
            row.RealName
          }”考生, 是否继续?`;
      this.$confirm(str, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const obj = {
            guid: JSON.parse(loginvuex.state.userlist).guid,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            hid: JSON.parse(loginvuex.state.userlist).hid,
            studentArr: '',
            isAgree: type, // 是否同意 1:同意，2:拒绝
          };
          if (types) {
            // 批量
            obj.studentArr = row;
          } else {
            obj.studentArr = `[${row.UserID}]`;
          }
          console.log(obj);
          const { data } = await systemclass.updatePTitle(obj);
          if (data.Status == 200) {
            this.$message({
              message: data.Data,
              type: "success",
            });
            this.getDatalist(); // 重新发起请求
          } else {
            this.$message.error(data.Data);
          }
          console.log(data, "???");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 批量审批
    // 批量移除初始化
    batchDeleteInit(type) {
      if (this.multipleSelection.length < 1) {
        this.$message.warning(`请选择要${type == 1 ? "通过" : "拒绝"}的考生`);
        return;
      } else {
        this.examine(type, JSON.stringify(this.multipleSelectionIds), "arr");
      }
      console.log(this.multipleSelection, this.multipleSelectionIds);
    },
  },
};
</script>

<style lang="scss" scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
::v-deep .el-form {
  display: flex;
  .el-form-item__label {
    width: 100px !important;
  }
  .el-form-item__content {
    margin-left: 100px !important;
  }
  .el-input > .el-input__inner {
    // width: 220px;
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
.hos_mian {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(12) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
}
::v-deep .el-table .blue .cell {
  color: #409eff !important;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.operation_box {
  .el-button {
    font-size: 16px;
    &:nth-child(4) {
      color: #ff0000;
    }
  }
}
::v-deep .el-table-column--selection .cell {
  text-align: center;
}
::v-deep .el-table .cell {
  text-align: center;
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
  display: flex;
  justify-content: center;
}
::v-deep .el-table .yellow .cell {
  color: #ffa200 !important;
  display: flex;
  justify-content: center;
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
  display: flex;
  justify-content: center;
}
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 120px;
  }
  .el-button:nth-child(2) {
    background: #ee6717;
    width: 120px;
  }

  .el-button:nth-child(3) {
    background: #e54d4d;
    width: 104px;
    span > i {
      font-size: 16px !important;
      margin-right: 5px;
    }
  }
}
.isselectico {
  color: #1890ff;
  cursor: pointer;
  font-size: 28px;
}
.qrcodeView {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog {
    min-width: 342px !important;
    // min-height: 280px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      &:nth-child(2) {
        margin-left: 24px;
      }
    }
  }
  .red_p {
    color: #333333;
    margin-bottom: 10px;
    span {
      color: #e54d4d;
      font-size: 16px;
    }
  }
}
.mr24 {
  margin-left: 110px;
  font-size: 16px;
}
.delete_view {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog {
    min-width: 342px !important;
    // min-height: 280px !important;
    border-radius: 5px 5px 0px 0px;
  }
  ::v-deep .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      &:nth-child(2) {
        margin-left: 24px;
      }
    }
  }
}
// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 115px !important;
    }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}
.content_table {
  margin: 24px;
}
</style>